import { TranslationKeys } from "../contexts/TranslationKeys";
import { Translator } from "../contexts/translator";

// ReportSubType's as stored in the database.D
export const ReportSubTypes = {
    STANDARD: "1", // Represents most reports.
    TODAY: "2",
    CURR_WEEK: "3",
    CURR_MONTH: "4",
    DENIED: "5",
    ALARMS: "6",
    STATUS: "7",
    GENERAL: "8",
    TIME_ATTENDANCE: "9",
    STILL_ON_SITE: "10",
    VINGCARD: "11"
}

// ReportType's as stored in the database.
export const ReportTypes = {
    TRANSACTION: "1",
    ABSENTEEISM: "2",
    ENROLMENTS: "3",
    ACCESS_GROUPS: "4",
    AREAS: "5",
    HOLIDAYS: "6",
    HOURS_WORKED: "7",
    ZONE_OCCUPANCY: "8",
    FIRST_IN_LAST_OUT: "9",
    HW_INSTALLATION: "10",
    HW_COMMS_CHANNEL: "11",
    CARDS_NOT_USED: "12",
    CARD_EXPIRY: "13",
    MUSTERING: "14",
    OCCUPANCY: "15",
    AUDIT: "16",
    DOOR_ACCESS: "17",
    PERSON_ACCESS: "19",
    GENERAL_ACCESS: "20",
    OPERATIONAL_COMPLIANCE: "21",
    SEQUENTIAL_EVENT: "22"
}

// These are not stored in the database but are used by backend to group reports for the frontend to show.
export const ReportCategories = {
    TRANSACTION: "1",
    TIME_AND_ATTENDANCE: "2",
    ACCESS_CONTROL: "3",
    SYSTEM_SETUP: "4",
    EMERGENCY_AND_SAFETY: "5",
    COMPLIANCE: '6'
}

export const FIRST_IN_ROW_TYPE  = 0;
export const LAST_IN_ROW_TYPE = 1;

export const getMusterReportStatus = (status: string, translate: Translator) => {
    const MUSTERING_REPORT_STATUSES = {
        ABSENT: translate.byKey(TranslationKeys.absent),
        MUSTERED: translate.byKey(TranslationKeys.mustered),
        UNACCOUNTED: translate.byKey(TranslationKeys.unaccounted),
        EXITED: translate.byKey(TranslationKeys.exited),
        MANUALLY_MUSTERED: translate.byKey(TranslationKeys.manuallyMustered),
    };

    return MUSTERING_REPORT_STATUSES[status]
}

export const GENERAL_MUSTERING_STATUS = {
    ALL: 0,
    ABSENT : 1,
    MUSTERED: 2,
    MANUALLY_MUSTERED: 3,
    UNACCOUNTED_FOR: 4,
    EXITED: 5
}